import { Component, inject, signal } from '@angular/core';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet} from '@angular/router';
import {SpinnerComponent} from './shared/modules/spinner/spinner.component';
import eruda from 'eruda';
import { LongPressDirective } from './shared/directives/long-press.directive';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SpinnerComponent, LongPressDirective],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'MindPlay';

  router = inject(Router);
  loading = signal(false);

  constructor() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loading.set(true);
      }

      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loading.set(false);
      }
    });
  }

  onDoubleClick() {
    // Initialize eruda
    eruda.init();
  }
}
